<template>
  <main class="w-full container">
    <vf-breadcrumbs
      class="mt-6 gap-x-2"
      :first-step="{ label: $t.help, url: '/help-section' }"
      :last-step="{ label: $t.faq }"
    />
    <section class="my-4">
      <h1 class="mb-6 text-center title-1">
        {{ headerTitle }}
      </h1>
      <base-grid :cols="{ sm: 2, lg: 3 }" gap="sm">
        <vf-tile v-for="(tile, key) in tiles" :key v-bind="tile" />
      </base-grid>
    </section>
  </main>
</template>

<script lang="ts" setup>
import type { PageConfig } from '#brand/types/pages/help-section/faq'

const { data, error } = await useApi().internal.getStaticPage<PageConfig>('help-section/faq')
const { $t } = useNuxtApp()

if (!data.value) throw createError({ ...error.value!, fatal: true })
const { headerTitle, tiles } = data.value
</script>
